var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bankForm"},[_c('base-form',{ref:"baseData",attrs:{"options":_vm.baseDataOptions,"label-width":"120px","disabled":!_vm.canEdit},on:{"change":_vm.handleBlurChangeBaseData,"input":_vm.handleChangeBaseData},model:{value:(_vm.baseData),callback:function ($$v) {_vm.baseData=$$v},expression:"baseData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }